import React from 'react';
import { useParams } from 'react-router-dom';
import WbsEditorContainer from './WbsEditorContainer';

export default function WbsEditorPage() {
    const { projectId } = useParams<{ projectId: string }>();

    if (!projectId?.trim()) {
        return <div className="p-6 text-sm text-rose-700">잘못된 프로젝트 ID 입니다.</div>;
    }
    return (
        <div className="h-full bg-white rounded-2xl overflow-hidden border">
            <WbsEditorContainer projectId={projectId} />
        </div>
    );
}
